import React from  'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Spinner from '../Spinner/Spinner';
// import MediaQuery from 'react-responsive';


let order = 'desc';

var divStyle = {
  color: 'black',
};

function emailFormatter(cell, row){
  return <a style={divStyle} href={`mailto:${cell}`}><i className="fa fa-envelope" aria-hidden="true"></i></a>;
}

// function roundFormat(cell, row){
//   return  Math.round(cell * 100) / 100;
// }

function viewSample(cell, row){
  return  <a href={"/view-spaces/" + cell} style={divStyle}>
            <i className="fa fa-search" aria-hidden="true"></i>
          </a>;
}

export default class Library extends React.Component {

  constructor(props) {
    super(props);
    this.state={
      libraryItems: [],
    };
  }


  componentWillMount(){
    fetch("https://jelf6b1p53.execute-api.ap-southeast-2.amazonaws.com/prod/get-spaces")
    .then(result=>result.json()).then(json => {

      this.setState({ libraryItems: json });
    });
  }

  handleBtnClick = () => {
    if (order === 'desc') {
      this.refs.table.handleSort('asc', 'name');
      order = 'asc';
    } else {
      this.refs.table.handleSort('desc', 'name');
      order = 'desc';
    }
  }

  createDash(){
    if(!this.state.libraryItems){
      return (
        // <Spinner/>
        <div className="container"></div>
    )
    }else{
      return (
        <div>
        <br/><br/>
        <h2>Spaces</h2>
        <br/>
        <BootstrapTable  ref='table' data={ this.state.libraryItems } version='4' >
        <TableHeaderColumn  width='220px' dataField='date' dataSort={ true }>Date [UTC]</TableHeaderColumn>
          <TableHeaderColumn  width='220px' dataField='project' filter={ { type: 'TextFilter', delay: 500 } } dataSort={ true }>Project</TableHeaderColumn>
          <TableHeaderColumn dataField='owner' filter={ { type: 'TextFilter', delay: 500 } } dataSort={ true }>Owner</TableHeaderColumn>
          <TableHeaderColumn dataField='email' width='80px' dataFormat={ emailFormatter }>Email</TableHeaderColumn>
          <TableHeaderColumn isKey={ true } width='130px' dataField='id' dataFormat={viewSample}>View Space</TableHeaderColumn>
        </BootstrapTable>
      </div>
      )
    }
  }

  render(){
    const { isAuthenticated } = this.props.auth;
    console.log(isAuthenticated)
    return (
      <div className="container">
      {isAuthenticated() ? (this.createDash()): null}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Library/Library.js